import React from 'react'
import _ from 'lodash'
import { Portal } from 'react-portal'
import styled from 'styled-components'
import IconCrossLight from '../images/icon_cross_light.svg'

export const StyledAlert = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 101;

  padding: 34px 24px 34px;
  margin: 10px;
  /* text-align: center; */

  background-color: ${props => !!props.bgColor ? props.bgColor: '#17a2b8'};
  background-color: ${props => !!props.bgColor ? props.bgColor: '#17a2b8'}${props => !!props.bgOpacity ? Math.round(props.bgOpacity * 255).toString(16) : 'ff'};
  color: ${props => !!props.textColor ? props.textColor: 'white'};
  /* max-width: ${props => !!props.style ? '500px':'900px'}; */

  font-family: 'ABChanel PB Regular L', Arial, sans-serif;
  font-size: 10px;
  line-height: 1.2em;
  text-align: center;
  -webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

  html[lang=tw] & {
    font-size: 14px;
  }

  @media only screen and (min-width: 768px) {
    padding: 34px 60px 34px 20px;
    margin: 0;
    font-size: 12px;
    text-align: left;
  }
`

export const MessageWrapper = styled.div`
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  > *:last-child {
    margin-bottom: 0;
  }
`

export const CloseButton = styled.span`
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
  @media only screen and (min-width: 768px) {
    top: 20px;
    right: 20px;
  }
`

class Alert extends React.Component {
  _timeout = null
  types = {
    primary: {
      bgColor: '#007bff',
      textColor: 'white'
    },
    secondary: {
      bgColor: '#6c757d',
      textColor: 'white'
    },
    success: {
      bgColor: '#28a745',
      textColor: 'white'
    },
    danger: {
      bgColor: '#eb4949',
      textColor: 'white',
      closeButtonColor: 'white'
    },
    warning: {
      bgColor: '#ffc107',
      textColor: 'black'
    },
    info: {
      bgColor: '#17a2b8',
      textColor: 'white'
    },
    light: {
      bgColor: '#f8f9fa',
      textColor: 'black'
    },
    dark: {
      bgColor: '#343a40',
      textColor: 'white'
    },
    white: {
      bgColor: '#ffffff',
      textColor: 'black'
    },
    black: {
      bgColor: '#000000',
      textColor: 'white'
    }
  }

  state = {
    open: false
  }

  open = (type = 'danger', duration = 30000) => {
    this.setState({open: true, type }, () => {
      this._timeout = setTimeout( () => this.close(), duration)
    })
  }

  close = () => {
    clearTimeout(this._timeout)
    this.setState({open: false})
  }

  render() {
    if (!this.state.open) return null
    const { closeButton, message } = this.props
    const { type } = this.state

    if (!message) return null
    return (
      <Portal>
        <StyledAlert bgColor={this.types[type].bgColor} bgOpacity={.96} textColor={this.types[type].textColor}>
          <MessageWrapper>
            <p>{message}</p>
            {this.props.children}
          </MessageWrapper>
          <CloseButton onClick={this.close}>
            {
              !_.isEmpty(closeButton)
                ? closeButton
                : <img src={IconCrossLight} alt='' />
            }
          </CloseButton>
        </StyledAlert>
      </Portal>
    )
  }
}



Alert.defaultProps = {
  type: 'info',
  closeButton: '',
  message: ''
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/Alert.js